import { Box} from '@chakra-ui/react'
import { ContentNotFound, Hero, Layout, TwoColBlockSection } from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const MembershipScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }
  return (
    <Layout
      title={pageData.data.pageTitle}
      navigation={navigation}
      path={asPath}
    >
      <Hero
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
        bgImageUrl={pageData.data.hero.bgImageUrl}
        mobileBgImageUrl={pageData.data.hero.bgImageUrlMobile}
      />
      {pageData.data.tickets && pageData.data.tickets.length > 0 && (
        <Box as="main" pt={4} mt={5}>
          <TwoColBlockSection
            stickyId="membershipAndRenewal"
            sectionTitle={t('common:membershipAndRenewal')}
            data={pageData.data.tickets}
          />
        </Box>
      )}
    </Layout>
  )
}

export default MembershipScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getMembershipPage(locale)

  return {
    props: { pageData },
  }
}
